import React from 'react';
import { compact } from 'lodash';
import { Link } from 'react-router-dom';
import { Typography, TableList } from 'seagull';
import { routes } from "../../../constants";
export const RemainingCreditRow = props => {
  const {
    data
  } = props;
  const items = compact([{
    value: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      as: Link,
      to: routes.agreement(data.relationshipId),
      "data-testid": "remaining-credit-report-row-customer",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, data.customerName))
  }, {
    value: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "remaining-credit-report-row-agreement",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, data.agreementName))
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "remaining-credit-report-row-service",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, data.serviceName)
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "remaining-credit-report-row-rate",
      variant: "paragraph1",
      noWrap: true
    }, data.credit)
  }]);
  return /*#__PURE__*/React.createElement(TableList.Row, {
    items: items,
    rowId: props.index,
    "data-testid": "remaining-credit-report-row-".concat(props.index),
    "data-heapid": "remaining-credit-report-row"
  });
};